import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'formatCurrency'
})
export class FormatCurrencyPipe implements PipeTransform {
	transform(amount: number | undefined | null): string {
		if (!amount && amount !== 0) {
			return '--';
		}

		return new Intl.NumberFormat('en-PH', {
			style: 'currency',
			currency: 'PHP'
		}).format(amount);
	}
}
